export type ReversibleCacheUpdate = () => { undo: () => void };

interface OptimisticUpdateParams<Result> {
  cacheUpdate: ReversibleCacheUpdate;
  query: Promise<Result>;
  onSuccess?: (result: Result) => void;
}

export const optimisticUpdate = async <Result>({
  query,
  cacheUpdate,
  onSuccess,
}: OptimisticUpdateParams<Result>) => {
  const cacheUpdateResult = cacheUpdate();

  try {
    const result = await query;

    onSuccess?.(result);
  } catch {
    cacheUpdateResult.undo();
  }
};
